import React from "react";

import Button from "ui/Button";
import { SlackLogo } from "ui/Icons";
import { useAppConfig } from "providers/WithAppConfig";

import styles from "./style.module.scss";
import { csrfTag } from "utils/csrf";

const ConnectToSlack: React.FunctionComponent = () => {
  const config = useAppConfig();

  const available = config?.slackIntegrationAvailable;
  if (!available) {
    return (
      <button disabled className="btn btn-secondary disabled">
        <span className="flex items-center justify-center gap-1.5">
          <SlackLogo />
          Not Available
        </span>
      </button>
    );
  }

  return (
    <form action="/users/auth/slack" method="post">
      {csrfTag()}
      <Button type="submit" className={styles.connectBtn}>
        <span className="flex items-center justify-center gap-1.5">
          <SlackLogo />
          Connect to Slack
        </span>
      </Button>
    </form>
  );
};

export default ConnectToSlack;
